"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _BottomSection = _interopRequireDefault(require("../BottomSection"));
var _TopSection = _interopRequireDefault(require("../TopSection"));
var _Modal = _interopRequireDefault(require("../Modal"));
require("./styles.css");
var _react = require("react");
var _ModalState = _interopRequireDefault(require("../../state-observables/modal/ModalState"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LandingPage = () => {
  const [modalData, setModalData] = (0, _react.useState)(null);
  const [shouldCloseModal, setShouldCloseModal] = (0, _react.useState)(false);
  const modalSubscriptionHelper = {
    notify(eventTopic, eventData) {
      switch (eventTopic) {
        case "SetModal":
          setModalData(eventData);
          break;
        case "CloseModal":
          setShouldCloseModal(true);
          break;
      }
    }
  };

  // Create subscription to the modal state
  (0, _react.useEffect)(() => {
    // Subscribe
    _ModalState.default.subscribe(modalSubscriptionHelper, ["SetModal", "CloseModal"]);

    // Return unsubscribe function
    return () => {
      _ModalState.default.unsubscribe(modalSubscriptionHelper);
    };
  }, []);
  const resetModal = () => {
    setShouldCloseModal(false);
    setModalData(null);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!!(modalData !== null && modalData !== void 0 && modalData.modalContent) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, {
      title: modalData ? modalData.modalTitle : "",
      modalResetter: resetModal,
      shouldCloseModal: shouldCloseModal,
      withLogo: true,
      children: modalData && modalData.modalContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(modalData.modalContent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
      id: "modal-main-container"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("main", {
      className: "landing-page-outer-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TopSection.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BottomSection.default, {})]
    })]
  });
};
var _default = exports.default = LandingPage;